export default __webpack_public_path__ + "static/media/Shadows.31d6cfe0.svg";